module.exports = __webpack_public_path__ + "static/img/bg.33c6f06a.webp";